
import { useApiStore } from "@/stores/apiStore";
import { useAuthStore } from "@/stores/authStore";
import { useToastStore } from "@/stores/toastStore";
import { AxiosError } from "axios";
import { defineComponent } from "vue";

export default defineComponent({
	setup() {
		const api = useApiStore();
		const authStore = useAuthStore();
		const toast = useToastStore();
		return {
			api,
			authStore,
			toast
		};
	},
	name: "imdex-request-access",
	data: () => {
		return {
			// eslint-disable-next-line

			email: useAuthStore().user?.email,
			isLoading: false,
			isAccessRequested: useAuthStore().user?.isAccessRequested,
			isActive: useAuthStore().user?.isActive,
			errorMessage: ""
		};
	},
	methods: {
		async requestAccess() {
			this.isLoading = true;
			try {
				await this.api.get(`/request-access?email=${this.email}`);

				// switch to "Access Requested" screen
				this.isAccessRequested = true;
			} catch (e) {
				if (e instanceof AxiosError) {
					this.errorMessage = e.response?.data.message;
					this.toast.toast({
						message: this.errorMessage,
						title: this.$t(`requestAccess.errorRequestFailed`),
						dismissable: false,
						type: "error"
					});
				}
			} finally {
				this.isLoading = false;
			}
		},
		async logoutAndBack() {
			this.authStore.logout();
		}
	}
});
